import { render, staticRenderFns } from "./CompositionEditor.vue?vue&type=template&id=f641a026&"
import script from "./CompositionEditor.vue?vue&type=script&lang=js&"
export * from "./CompositionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports